<div class="modal-container">
    <button
        id="modalSeleccionElemento"
        #modalSeleccionElemento
        data-bs-toggle="modal"
        data-bs-target="#modalElemento"
        hidden="hidden"
        hidden
    aria-hidden="true"
    tabindex="-1">
        Launch
    </button>
    <div
        class="modal fade"
        id="modalElemento"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="modalTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row align-items-center">
                        <div class="modal-icon text-box">
                            <span
                              class="govco-icon"
                              [ngClass]="'govco-info-circle'"></span>
                        </div>
                    </div>
                    <div class="row text-box">
                        <h3>{{"seleccion-entidad.informacion" | translate}}</h3>
                    </div>
                    <div class="row text-box">
                        <p>{{"seleccion-entidad.mensaje-usuario" | translate}}</p>
                    </div>
                    <div class="row">
                        <div class="mt-3 d-flex gap-2 justify-content-center">
                            <button
                                type="button"
                                (click)="onSubmitSeleccionarElemento()"
                                class="btn-govco fill-btn-govco"
                                aria-label="Ayuda">
                              {{"seleccion-entidad.ayuda" | translate}}
                            </button>
                            <button
                                type="button"
                                class="btn-govco btn-govco"
                                data-bs-dismiss="modal"
                                aria-label="Trámite directo">
                              {{"seleccion-entidad.tramite-directo" | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
